import client from './client';
import qs from 'qs';

/**
 * 컴바인로그인
 * @param {String} token (mobon token)
 */
export const different = (mobToken) =>
  client.get(`/api/move/different`, { params: mobToken });

/**
 * 토근 유효성검사 (JWT token)
 */
export const tokenCheck = () => client.get(`/api/tokenCheck`);

/**
 *  토큰삭제
 *  @param {String} token
 */
export const tokenDelete = (token) =>
  client.delete(`/api/move/tokenDel`, { data: { token: token } });

// 로그인
export const login = ({ userId, password }) =>
  client.post('/api/login', qs.stringify({ userId, password }));

// 로그아웃
export const logout = () => client.post('/api/logout');

/**
 * 패스워드 재확인
 * @param {string} password
 */
export const checkPassword = (params) => client.post(`/api/rePassword`, params);

// export const changePassword = ({ USER_ID, newPassword, confirmPassword }) =>
export const changePassword = (newPassword, confirmPassword) =>
  client.post(
    `/api/changePassword`,
    qs.stringify({
      password: newPassword,
      password_confirmation: confirmPassword,
    })
  );

/**
 *
 * @param {string} 이메일 재설정 알림 요청
 */
export const findPassword = (email) =>
  client.post(
    `/api/noti/password`,
    qs.stringify({
      email,
    })
  );

// 비밀번호 찾기용 패스워드 변경
export const notiChangePassword = (userId, newPassword, confirmPassword) =>
  client.post(
    `/api/noti/changePassword`,
    qs.stringify({
      userId: userId,
      password: newPassword,
      password_confirmation: confirmPassword,
    })
  );

/**
 * 권한관리에 쓰이는 메뉴 전체 리스트
 */
export const allMenuList = () => client.get(`/api/manage/auth/menu/all`);

/**
 * 권한 - 그룹 리스트
 */
export const authGrpList = (param) =>
  client.get(`/api/manage/auth/group/list`, { uri: param });

/**
 * 권한 메뉴관리 - 메뉴별 그룹리스트
 */
export const authMenuGroupList = (param) =>
  client.get(`/api/manage/auth/group/menuList`, param);

/**
 * 권한 - 그룹 추가
 */
export const authGrpCreate = (grpName, grpSortNo) =>
  client.post(
    `/api/manage/auth/group/create`,
    qs.stringify(grpName, grpSortNo)
  );

/**
 * 권한 - 그룹 사용자 추가
 */
export const authUserMapping = (params) =>
  client.post(`/api/manage/auth/group/mapping?` + qs.stringify(params));

/**
 * 권한 - 그룹 수정
 */
export const authGrpModify = (param) =>
  client.post(`/api/manage/auth/group/modify`, qs.stringify(param));

/**
 * 권한 - 그룹 삭제
 */
export const authGrpDelete = (param) =>
  client.delete(`/api/manage/auth/group/delete`, { data: { grpNo: param } });

/**
 * 권한 - 매핑 그룹 삭제
 */
export const groupUserMappingDelete = (param) =>
  client.delete(`/api/manage/auth/group/userDelete`, {
    data: param,
  });

/**
 * 권한 - 메뉴관리 - 메뉴 리스트
 */
export const authMenuList = (param) =>
  client.get(`/api/manage/auth/menu/list`, param);

/**
 * 권한 - 메뉴관리 - 메뉴 추가
 */
export const authMenuAdd = (param) =>
  client.post(`/api/manage/auth/menu/create`, qs.stringify(param));

/**
 * 권한 - 메뉴관리 - 메뉴 수정
 */
export const authMenuModify = (param) =>
  client.post(`/api/manage/auth/menu/modify`, qs.stringify(param));

/**
 * 권한 - 메뉴관리 - 유저 맵핑
 */
export const userMapping = (param) =>
  client.post(`/api/manage/auth/menu/mapping`, qs.stringify(param));

/**
 * 권한 - 메뉴관리 - 메뉴 삭제
 */
export const authMenuDelete = (menuNo) =>
  client.delete(`/api/manage/auth/menu/delete?menuNo=` + menuNo);

/**
 * 권한 - 메뉴관리 - 메뉴 삭제
 */
export const userMappingDelete = (param) =>
  client.delete(`/api/manage/auth/menu/userDelete`, {
    data: param,
  });

/**
 * 권한 - 메뉴관리 - 메뉴 삭제
 */
export const groupMenuMappingDelete = (param) =>
  client.delete(`/api/manage/auth/group/menuDelete`, {
    data: param,
  });

/**
 * 권한 메뉴관리 - 메뉴별 유저리스트
 */
export const authMenuUserList = (param) =>
  client.get(`/api/manage/auth/menu/userList`, param);

/**
 * 권한 메뉴관리 - 메뉴별 유저 + 그룹 리스트
 */
export const authMenuUserGroupList = (param) =>
  client.get(`/api/manage/auth/lists?menuNos=` + param);

/**
 * 권한 메뉴관리 - 메뉴별 유저 그룹 쓰기권한 수정
 */
export const authGroupWrite = (param) =>
  client.post(`/api/manage/auth/group/write`, param);

/**
 * 권한 메뉴관리 - 유저별 유저 그룹 쓰기권한 수정
 */
export const authUserWrite = (param) =>
  client.post(`/api/manage/auth/user/write`, param);

/**
 * 대형광고주 리스트
 */
export const bigAdver = () =>
  client.get(
    `/api/manage/auth/allUser?grpNo=150&page=1&limit=50&uri=/system/auth/group`
  );

/**
 * 권한 - 그룹 유저 리스트
 */
export const authUserList = (param) =>
  client.get(`/api/manage/auth/user`, param);

/**
 * 권한 - 계정관리 - 유저 삭제
 */
export const userDelete = (param) =>
  client.delete(`/api/manage/auth/user/delete`, {
    data: param,
  });

/**
 * 권한 - 계정관리 - 유저별 권한 리스트
 */
export const userAuthList = (param) =>
  client.get(`/api/manage/auth/user/authList?` + qs.stringify(param));

/**
 * 다큐먼트
 */
export const documentList = (params) =>
  client.get(`/api/system/document`, params);

export const documentSetList = (params) =>
  client.post(`/api/system/document`, params);

export const documentDelete = (params) =>
  client.delete(`/api/system/document`, {
    data: params,
  });

export const documentSystemList = (params) =>
  client.get(`/api/system/systemDocument`, params);

export const documentSystemSetList = (params) =>
  client.post(`/api/system/systemDocument`, params);

export const documentSystemDelete = (params) =>
  client.delete(`/api/system/systemDocument`, {
    data: params,
  });
